import { render } from "./CompanyReportCWKList.vue?vue&type=template&id=fe7f2ed8&ts=true"
import script from "./CompanyReportCWKList.vue?vue&type=script&lang=ts"
export * from "./CompanyReportCWKList.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__